import { EntityListBuilder } from '../../../../shared/lib/entityListBuilder';
import { fieldNames } from '../../common/config';

const fields = {
  startDate: (initialValue) => ({
    props: { span: 12 },
    fields: [{ name: fieldNames.startDate, initialValue }],
  }),

  planEndDate: (initialValue) => ({
    props: { span: 12 },
    fields: [{ name: fieldNames.planEndDate, initialValue }],
  }),

  endDate: (initialValue) => ({
    props: { span: 12 },
    fields: [{ name: fieldNames.endDate, initialValue }],
  }),

  type: (initialValue) => ({
    props: { span: 12 },
    fields: [{ name: fieldNames.type, initialValue }],
  }),

  reason: (initialValue) => ({
    props: { span: 12 },
    fields: [{ name: fieldNames.reason, initialValue }],
  }),

  initiators: (initialValue) => ({
    props: { span: 12 },
    fields: [{ name: fieldNames.initiators, initialValue }],
  }),

  mainInitiator: (initialValue) => ({
    props: { span: 12 },
    fields: [{ name: fieldNames.mainInitiator, initialValue }],
  }),

  responsible: (initialValue) => ({
    props: { span: 12 },
    fields: [{ name: fieldNames.responsible, initialValue }],
  }),

  notifyTo: (initialValue) => ({
    props: { span: 12 },
    fields: [{ name: fieldNames.notifyTo, initialValue }],
  }),

  alisaTemplate: (initialValue) => ({
    fields: [{ name: fieldNames.alisaTemplate, initialValue }],
  }),

  alisaText: (initialValue) => ({
    fields: [{ name: fieldNames.alisaText, initialValue }],
  }),

  description: (initialValue) => ({
    fields: [{ name: fieldNames.description, initialValue }],
  }),

  files: (initialValue) => ({
    fields: [{ name: fieldNames.files, initialValue }],
  }),

  addresses: (initialValue) => ({
    fields: [{ name: fieldNames.addresses, initialValue }],
  }),

  enableAlisa: (initialValue) => ({
    fields: [{ name: fieldNames.enableAlisa, initialValue }],
  }),

  city: (initialValue) => ({
    fields: [{ name: fieldNames.city, initialValue }],
  }),
  company: (initialValue) => ({
    fields: [{ name: fieldNames.company, initialValue }],
  }),
};

export const createFormRows = ({ initialValues }) => {
  const {
    startDate,
    planEndDate,
    endDate,
    type,
    alertReason,
    initiators,
    executors,
    description,
    alisaText,
    notifyTo,
  } = initialValues || {};

  const rows = new EntityListBuilder();

  const mainInitiatorValue = initiators?.find((initiator) =>
    Boolean(initiator.isMain)
  );

  rows
    .addItem({ cols: [fields.company()] })
    .addItem({ cols: [fields.city()] })
    .addItem({
      props: { gutter: 16 },
      cols: [fields.startDate(startDate), fields.planEndDate(planEndDate)],
    })
    .addItem({
      props: { gutter: 16 },
      cols: [fields.reason(alertReason?.id), fields.type(type?.id)],
    })
    .addItem({
      props: { gutter: 16 },
      cols: [
        fields.initiators(initiators?.map((initiator) => initiator.id) || []),
        fields.mainInitiator(mainInitiatorValue || undefined),
      ],
    })
    .addItem({
      props: { gutter: 16 },
      cols: [
        fields.responsible(executors?.map((item) => item.id) || []),
        fields.notifyTo(notifyTo?.map((item) => item.id) || []),
      ],
    })
    .addItem({ cols: [fields.endDate(endDate)] })
    .addItem({
      cols: [fields.enableAlisa()],
    })
    .addItem({
      props: { gutter: 16 },
      cols: [fields.alisaTemplate()],
    })
    .addItem({ cols: [fields.alisaText(alisaText)] })
    .addItem({ cols: [fields.description(description)] })
    .addItem({ cols: [fields.files()] })
    .addItem({ cols: [fields.addresses()] });

  return rows.getList();
};
